import React, {Fragment, useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';

import {ConfirmationDialog} from '../ConfirmationDialog';
import {GenericModelViewer} from '../GenericModelViewer';

import {FileUpload} from '../../../Models/StreamBank/FileUpload';
import {SB_ENTER_KEY_CODE} from "../../../Constants";
import {KeyboardUtils} from "../../../Utils";
import {useValidations} from "../../../Hooks/GenericModelHooks";

const model = new FileUpload();

export const FileEditOverlay = (props) => {
    const {
        Display,
        File,
        CanDelete,
        OnClose,
        OnSave,
        OnDelete,
        OnUpdate,
        OnValidationUpdate,
        Validation
    } = props;

    const [validations, setValidations, isValid] = useValidations();
    const [showDelete, setShowDelete] = useState(false);

    const handleKeyDown = (e) => {
        if (Display) {
            KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, e, onSaveClick);
    }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [Display]);

    const onCloseClick = () => {
        if(OnClose) {
            OnClose();
        }
    };

    const onSaveClick = () => {
        if(OnSave) {
            OnSave();
        }
    };

    const onDeleteClick = () => {
        if(OnDelete) {
            OnDelete();
            setShowDelete(false);
    }
    };

    const updateFile = (file) => {
        if(OnUpdate) {
            OnUpdate(file);
        }
    };

    const updateValidation = (validation, editorGuid) => {
        if(OnValidationUpdate) {
            OnValidationUpdate(validation, editorGuid);
        }
    };

    if(!File || !Display) {
        return null;
    }

    return (
        <Fragment>
            <ConfirmationDialog
                size="lg"
                Title={File.name}
                Body={
                    <Row>
                        <Col xs={12}>
                            <GenericModelViewer
                                Data={File}
                                IsNewModel={false}
                                EditMode={true}
                                Model={model}
                                Update={updateFile}
                                OnValidationUpdate={setValidations}
                                DefaultSelectedFieldDefKey="name"
                            />
                        </Col>
                    </Row>
                }
                CancelButtonMessage="Cancel"
                ConfirmationButtonMessage="Save"
                Display={Display && !showDelete}
                OnDelete={OnDelete ? () => setShowDelete(true) : null}
                OnClose={onCloseClick}
                OnConfirm={onSaveClick}
                DisableConfirmationButton={!isValid}
                DisableDeleteButton={!CanDelete}
            />
            <ConfirmationDialog
                Title="Confirmation"
                Body={`Are you sure you want to delete ${File.name}?`}
                Display={showDelete}
                OnConfirm={onDeleteClick}
                OnClose={() => setShowDelete(false)}
            />
        </Fragment>
    );
};
